import {Typography} from '~library/atoms/Typography';

import './Header.sass';

export const Header = () => (
  <div className="egift-modal-header">
    <div className="egift-modal-header__go-back-button__content">
      <Typography
        variant="paragraph2"
        className="egift-modal-header__go-back-button__content__title"
      >
        Send a gift they&apos;ll love
      </Typography>
    </div>
  </div>
);
